<span #offsetsTargetA
      *ngIf="this.priceboxSection.isEmptyCell(column)"
      [class.offset-violated]="this.priceboxSection.doesViolateSpreadOffset(column.adjustments)"
      [class.spread-width-violated]="this.priceboxSection.doesViolateSpreadWidth(column.adjustments)"
      class="na price"
>
    <span
        [class.offset-violated]="this.priceboxSection.doesViolateSpreadOffset(column.adjustments)">N</span
    >/<span
    [class.spread-width-violated]="this.priceboxSection.doesViolateSpreadWidth(column.adjustments)">A</span>
     <ng-container>
        <ets-visible-offsets-component
            [adjustments]="column.adjustments"
            [mouseOverTarget]="offsetsTargetA"
            [target]="'PriceBox'"
        >
        </ets-visible-offsets-component>
     </ng-container>
</span>

<span #offsetsTarget *ngIf="!this.priceboxSection.isEmptyCell(column)">
     <span [ngClass]="this.getPriceColorClass(column?.price)" class="price"
      [class.theo]="this.hasTheoPrices(column.adjustments)"
     >
        {{ column?.price | currency:'USD':'symbol':'1.2-2' }}
     </span>
     <ng-container>
        <ets-visible-offsets-component
            [adjustments]="column.adjustments"
            [mouseOverTarget]="offsetsTarget"
            [target]="'PriceBox'"
        >
        </ets-visible-offsets-component>
     </ng-container>
</span>
